"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  LTextRImage = _require.LTextRImage;
const formatMultipleScenarios = (properties, {
  domains
} = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const modTitle = properties.modTitle,
    color = properties.color,
    title1 = properties.title1,
    content1 = properties.content1,
    title2 = properties.title2,
    content2 = properties.content2,
    title3 = properties.title3,
    content3 = properties.content3,
    title4 = properties.title4,
    content4 = properties.content4,
    _properties$imageSrc = properties.imageSrc,
    imageSrc = _properties$imageSrc === void 0 ? '' : _properties$imageSrc,
    _properties$imageLoca = properties.imageLocation,
    imageLocation = _properties$imageLoca === void 0 ? true : _properties$imageLoca; // 第一条数据是模块名称
  // 这个组件设计成8条数据用来构建 articleList
  const articleList = [{
    title: title1,
    content: content1
  }, {
    title: title2,
    content: content2
  }, {
    title: title3,
    content: content3
  }, {
    title: title4,
    content: content4
  }];
  const resultArticleList = articleList.map((item, index) => {
    const _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$content = item.content,
      content = _item$content === void 0 ? '' : _item$content;
    const formatContent = formatUrlInText(content, {
      reportEvent: 'click_multipleScenarios_richtext_href'
    });
    return {
      title,
      content: formatContent
    };
  });
  return {
    modTitle,
    configuration: {
      imageLocation,
      imageSrc,
      articleList: resultArticleList
    },
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatMultipleScenar = formatMultipleScenarios(data, {
        domains
      }),
      _formatMultipleScenar2 = _formatMultipleScenar.modTitle,
      modTitle = _formatMultipleScenar2 === void 0 ? '' : _formatMultipleScenar2,
      _formatMultipleScenar3 = _formatMultipleScenar.bgColor,
      bgColor = _formatMultipleScenar3 === void 0 ? '' : _formatMultipleScenar3,
      _formatMultipleScenar4 = _formatMultipleScenar.configuration,
      configuration = _formatMultipleScenar4 === void 0 ? {} : _formatMultipleScenar4;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_multipleScenarios', componentKey, modTitle])), /*#__PURE__*/React.createElement(LTextRImage, {
      configuration: configuration,
      flexTitle: modTitle,
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}